import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "@/app/constants";
import { useAuthStore } from "@/stores/authStore";
import { pickHomeForRole } from "@/app/router/roleHome";

/**
 * The client portal is for anybody whose login carries a CLIENT RECORD, not
 * only for `role === "CLIENT"` (unified requirements A9, register A-34).
 *
 * A client who is hired becomes STAFF and keeps their own portal; a member of
 * staff who buys a report personally gets one. The server enforces the same
 * rule (`actsAsClient` in AudienceGuard) — this only decides what to render.
 */
export function PortalGuard() {
  const { user } = useAuthStore();
  if (!user) return <Navigate to={ROUTES.login} replace />;
  if (user.role !== "CLIENT" && !user.contactId) {
    return <Navigate to={pickHomeForRole(user.role)} replace />;
  }
  return <Outlet />;
}
